<template>
  <div class="accueil">
    <!-- Btn Retour -->
    <v-btn
      @click="$router.go(-1)"
      class="btnRetour"
    >
    </v-btn>

    <!-- <a :href="publicPath + 'visites/lama/index.html'">
      <v-btn class="firstVisit"> </v-btn>
    </a> -->

    <span class="texteSentiers">{{ $t("logoTexte") }}</span>

    <div class="visites">
      <div v-for="sentier in sentiers" :key="sentier.name">
        <a :href="sentier.url">
          <v-btn
            class="visiteCard"
            :style="{ 'background-image': 'url(' + sentier.img + ')' }"
          >
            <span class="visiteName">{{ $t(sentier.name) }}</span>
          </v-btn>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Sentiers",
  components: {},
  data() {
    return {
      sentiers: [
        {
          name: "Centre Corse",
          img: "visites/img/centrecorse.png",
          url: "#",
          // url: "visites/lama/index.html",
        },
        {
          name: "Corte",
          img: "visites/img/corte.png",
          url: "#",
        },
        {
          name: "Cuttoli",
          img: "visites/img/cuttoli.png",
          url: "#",
        },
        {
          name: "Lama",
          img: "visites/img/lama.png",
          url: "#",
        },
        {
          name: "Lumio",
          img: "visites/img/lumio.png",
          url: "#",
        },
        {
          name: "Monacia",
          img: "visites/img/monaccia.png",
          url: "#",
        },
        {
          name: "Penta",
          img: "visites/img/penta.png",
          url: "#",
        },
        {
          name: "Pioggiola",
          img: "visites/img/pioggiola.png",
          url: "#",
        },
        {
          name: "Luri",
          img: "visites/img/luri.png",
          url: "#",
        },
        {
          name: "Sorio",
          img: "visites/img/sorio.png",
          url: "#",
        },
        {
          name: "Vero",
          img: "visites/img/vero.png",
          url: "#",
        },
        {
          name: "Pietrabugno",
          img: "visites/img/pietrabugno.png",
          url: "visites/pietrabugno/index.html",
          // url: "http://tests-sdp.arobase.corsica/pietrabugno/",
        }
      ],
    };
  },
  computed: {
    ...mapState({
      publicPath: "publicPathState",
    }),
  },
  methods: {},
};
</script>

<style scoped>
.accueil {
  background-image: url("../assets/maquette/fonds/background2.png");
  background-size: cover;
  height: 2242px;
  width: 1920px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.btnRetour {
  background-image: url("../assets/maquette/buttons/backButton.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 15px;
  left: 14px;
  width: 117px;
  height: 117px !important;
  z-index: 1;
}

.texteSentiers {
  font-size: 80px;
  color: white;
  position: absolute;
  top: 6px;
  left: 483px;
  font-family: "CenturyGothic";
}

.visites {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 175px;
  left: 56px;
}

.visiteCard {
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  width: 585px;
  height: 442px !important;
  margin-left: -7px !important;
  margin-right: -7px !important;
  margin-top: -7px !important;
  margin-bottom: -7px !important;
}

.visiteName {
  display: block;
  position: absolute;
  top: 138px;
  left: 82px;
  color: white;
  font-size: 36px;
  text-transform: none;
  font-family: "CenturyGothic";
}

.text-nowrap {
  -webkit-line-clamp: unset !important;
}
</style>
